import { render } from "./AdminTrainingUsersTable.vue?vue&type=template&id=13999e72"
import script from "./AdminTrainingUsersTable.vue?vue&type=script&lang=js"
export * from "./AdminTrainingUsersTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__